/**
 * PayableHelpers
 *
 * Helper functions for payable statement transactions
 */

export const isTransactionInvoiced = (transaction) => {
    if (transaction.isPayment) {
        return false;
    }
    return transaction.Statements.some((st) => st.InvoiceID);
};

export const isTransactionInvoicePosted = (transaction) => {
    if (transaction.isPayment) {
        return false;
    }
    return transaction.Statements.some((st) => st.InvoicePosted);
};

export const isTransactionPaid = (transaction) => {
    if (transaction.isPayment) {
        return false;
    }
    return transaction.Statements.some((st) => st.PaidStatus === 'Paid');
};

export const isTransactionInNetwalk3Payment = (transaction) => {
    if (transaction.isPayment) {
        return false;
    }
    return transaction.Statements.some((st) => st.IsInNw3Payment || st.Nw3PaymentID);
};

export const isTransactionPrevisional = (transaction) => {
    if (transaction.isPayment) {
        return false;
    }
    const previsionalStatuses = ['Billable', 'Job', 'Option'];
    if (transaction.ClientID && previsionalStatuses.includes(transaction.ClientInvoiceStatus)) {
        return true;
    }
    return false;
};

export const isTransactionHold = (transaction) => {
    if (transaction.isPayment) {
        return false;
    }
    return transaction.Statements.some((st) => st.OnHold);
};

export const isTransactionNw3Locked = (transaction) => {
    if (transaction.isPayment) {
        return false;
    }
    return transaction.Statements.some((st) => st.Nw3Locked);
};

export const searchInText = (text, searchTerm) => {
    if (text && text.toLowerCase().includes(searchTerm.toLowerCase())) {
        return true;
    }
    return false;
};

export const filterTransactions = (transactions, searchTerm) => {
    return transactions.filter((transaction) => {
        if (
            searchInText(transaction.Label, searchTerm) ||
            searchInText(transaction.Title, searchTerm) ||
            searchInText(transaction.Description, searchTerm) ||
            (transaction.Project &&
                (searchInText(transaction.Project.Name, searchTerm) ||
                    searchInText(transaction.Project.Description, searchTerm)))
        ) {
            return true;
        }
        return false;
    });
};

export const getTableClassName = (isPrevisional, isHold) => {
    let cn = 'statement-table';
    if (isPrevisional) {
        cn += ' statement-table-previsional';
    }
    if (isHold) {
        cn += ' statement-table-hold';
    }
    return cn;
};

export const getRowClassName = (record, isTransactionPaid) => {
    let cn = 'statement-row';
    if (record.isPayment) {
        return cn + ' statement-row-payment';
    }
    if (isTransactionPaid(record)) {
        cn += ' statement-row-paid';
    }
    if (record.WorkDateCancelled) {
        cn += ' cancelled';
    }
    return cn;
};
